import scrollMonitor from 'scrollmonitor'

export default () => {
  const monitor = document.querySelector('.js-sticky-share-container') // sticky-share.twig
  const sticky = document.querySelector('.js-sticky-share')
  const end_monitor = document.querySelector('.js-sticky-end') // post-footer.twig

  if (! monitor || ! end_monitor) return

  const watcher = scrollMonitor.create(monitor, 0)
  const bottom_watcher = scrollMonitor.create(end_monitor, -100)

  watcher.enterViewport(() => {
    sticky.classList.remove('active')
  })

  watcher.stateChange(() => {
    if (watcher.isAboveViewport) {
      sticky.classList.add('active')
    } else {
      sticky.classList.remove('active')
    }
  })

  bottom_watcher.enterViewport(() => {
    sticky.classList.remove('active')
  })

  bottom_watcher.stateChange(() => {
    if (bottom_watcher.isBelowViewport) {
      sticky.classList.add('active')
    }
  })

}



// WEBPACK FOOTER //
// ./src/js/modules/StickyShare.js